import { put, takeLatest } from "@redux-saga/core/effects";
import axios from "axios";
import { setLastUpdatedLiveData, updateLiveDataToStore } from "../actions/LiveData";
import {
    GET_LAST_UPDATED_LIVE_DATA,
    GET_LIVE_DATA,
    getLastUpdatedLiveDataAction,
    setLastUpdatedLiveDataAction,
    updateLiveDataAction
} from "../actions/LiveData/types";
import { showError } from "../components/commonUtilities";
import { GeneratorYieldType } from "../interfaces/ActionReducer/GetMethod/GetResponse";

function* getLiveData(): Generator<
    Promise<updateLiveDataAction> | GeneratorYieldType<updateLiveDataAction["payload"]>,
    void,
    updateLiveDataAction["payload"]["data"]
> {
    try {
        const json = yield axios
            .get("/api/links/get_sensors_for_links/")
            .then((response) => response.data)
            .then((res) =>
                res.reduce(
                    (acc: object, current: object) => ({
                        ...acc,
                        ...current
                    }),
                    {}
                )
            );
        yield put(updateLiveDataToStore({ data: json }));
    } catch (e) {
        showError(e);
    }
}

export function* getLiveDataSaga() {
    yield takeLatest(GET_LIVE_DATA, getLiveData);
}

function* getLastUpdatedLiveData(): Generator<
    | Promise<setLastUpdatedLiveDataAction>
    | GeneratorYieldType<setLastUpdatedLiveDataAction["payload"]>,
    void,
    setLastUpdatedLiveDataAction["payload"]["data"]
> {
    try {
        const json = yield axios
            .get("/api/city-configuration/?config_key=demand_data_url")
            .then((response) => response.data.results[0]);
        yield put(setLastUpdatedLiveData({ data: json }));
    } catch (error) {
        showError(error);
    }
}

export function* getLastUpdatedLiveDataSaga() {
    yield takeLatest(GET_LAST_UPDATED_LIVE_DATA, getLastUpdatedLiveData);
}
